import { PasswordRegex } from './password_regex';

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export class ResponseMeta {
  page: number;
  pages: number;
  perpage: number;
  total: number;
  sort: SortOrder;
  field?: string;
}

export interface ConfigResponseData {
  dashboard_regex: PasswordRegex[];
  colors: {
    secondary: string;
    primary: string;
  };
  logo: string;
  logo_login: string;
  title_page: string;
  favicon: string;
  name: string;
  client_id: string;
  is_multi_team: boolean;
}

export interface PaginatedResponse<T> {
  data: T;
  meta: ResponseMeta;
}

export interface QueryParams {
  'sort[field]': string;
  'sort[sort]': SortOrder;
  'pagination[page]': string;
  limit: string;
}

export enum BrazilState {
  AC = 'AC',
  AL = 'AL',
  AM = 'AM',
  AP = 'AP',
  BA = 'BA',
  CE = 'CE',
  DF = 'DF',
  ES = 'ES',
  GO = 'GO',
  MA = 'MA',
  MG = 'MG',
  MS = 'MS',
  MT = 'MT',
  PA = 'PA',
  PB = 'PB',
  PE = 'PE',
  PI = 'PI',
  PR = 'PR',
  RJ = 'RJ',
  RN = 'RN',
  RO = 'RO',
  RR = 'RR',
  RS = 'RS',
  SC = 'SC',
  SE = 'SE',
  SP = 'SP',
  TO = 'TO',
}

export enum ExportType {
  CSV = 'CSV',
  XLSX = 'XLSX',
  ZIP = 'ZIP',
}

export enum PaymentMethod {
  PIX = 'PIX',
  CREDIT_CARD = 'CREDIT_CARD',
}

export enum CardBrand {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  DINERS = 'DINERS',
  DISCOVER = 'DISCOVER',
  ELO = 'ELO',
  AMEX = 'AMEX',
  JCB = 'JCB',
  HIPERCARD = 'HIPERCARD',
  MAESTRO = 'MAESTRO',
  OTHERS = 'OTHERS',
}
